import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-edit\"><path d=\"M880 848c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32H144c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32h736z m-48.935-695.065c56.674 56.673 57.24 148.207 1.7 205.578l-1.7 1.728L405.68 785.627A32.022 32.022 0 0 1 383.561 795H221c-17.496 0-31.713-14.042-32-31.47V600.947a32 32 0 0 1 9.016-22.265l0.357-0.362 425.386-425.386c57.246-57.247 150.06-57.247 207.306 0zM605.973 261.228L253 614.202V731h116.796L722.77 378.025 605.973 261.228z m64.014-63.996l-0.973 0.957-17.786 17.784L768.025 332.77l17.786-17.784c31.93-31.93 32.249-83.5 0.957-115.823l-0.957-0.974c-31.93-31.93-83.501-32.249-115.824-0.957z\" p-id=\"10116\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/edit.svg
// module id = ql+d
// module chunks = 41